import { t } from '@lingui/core/macro';
import { FieldNumericController } from '@luminovo/design-system';
import type { JSX } from 'react';
import { Control, FieldValues, Path } from 'react-hook-form';

export function FieldScrapAttrition<T extends FieldValues>({
    readOnly,
    control,
    name,
}: {
    readOnly: boolean;
    control: Control<T>;
    name: Path<T>;
}): JSX.Element {
    return (
        <FieldNumericController
            control={control}
            name={name}
            min={0}
            required
            representation="percent"
            FieldProps={{
                label: t`Run scrap (attrition)`,
                placeholder: t`Run scrap (attrition)`,
                slotProps: {
                    input: {
                        readOnly,
                    },
                },
            }}
        />
    );
}
